<div
  class="bg-transparent min-h-dvh w-full min-[2560px]:max-w-[2560px] min-[2560px]:mx-auto relative flex"
>
  <!-- Sidebar (side-menu only) -->
  @if (layoutService.actualNavigationMode() === 'side-menu') {
  <app-sidebar></app-sidebar>
  }

  <div class="flex-1 flex flex-col min-w-0">
    <!-- Standard Header (side-menu & bottom-bar) -->
    @if (layoutService.actualNavigationMode() !== 'top-bar') {
    <app-header id="region-header" tabindex="-1" class="focus:outline-none"></app-header>
    }

    <!-- Top Bar Header (top-bar only) -->
    @if (layoutService.actualNavigationMode() === 'top-bar') {
    <app-top-navigation id="region-header" tabindex="-1" class="focus:outline-none"></app-top-navigation>
    }

    <main
      id="region-content" tabindex="-1"
      class="bg-transparent flex-1 min-w-0 max-w-full overflow-x-clip transition-all duration-300 focus:outline-none"
      [style.margin-left.px]="layoutService.sidebarContentOffset()"
      [style.height]="
        layoutService.navigationMode() === 'side-menu'
          ? 'calc((var(--vh, 1dvh) * 100) - 64px)'
          : 'calc((var(--vh, 1dvh) * 100) - ' +
            (showDashboardFooter()
              ? layoutService.dashboardFooterOffset()
              : layoutService.isFooterTabsDisabled()
              ? '48px'
              : layoutService.standardFooterOffset()) +
            ')'
      "
      [style.padding-bottom]="
        layoutService.navigationMode() === 'side-menu'
          ? '0px'
          : showDashboardFooter()
          ? '100px'
          : '0px'
      "
      [style.padding-top]="layoutService.actualNavigationMode() === 'top-bar' ? '70px' : '80px'"
    >
      <router-outlet></router-outlet>
    </main>

    @if (showFooter() && layoutService.navigationMode() === 'bottom-bar') {
    <app-footer id="region-footer" tabindex="-1" class="focus:outline-none block"></app-footer>
    } @if (showDashboardFooter() && layoutService.navigationMode() ===
    'bottom-bar') {
    <app-dashboard-footer id="region-footer" tabindex="-1" class="focus:outline-none block"></app-dashboard-footer>
    }
  </div>
</div>


<app-ai-assistant-bot
  [visible]="guidanceService.showAiAssistant()"
  (visibleChange)="guidanceService.showAiAssistant.set($event)"
></app-ai-assistant-bot>

<app-widget-menu></app-widget-menu>
